import { Text } from "../../../../../i18n/text.js";
import { MenuContent } from "../../../../../ui/menu/content.js";
import { MenuItem } from "../../../../../ui/menu/item.js";
import { MenuRoot } from "../../../../../ui/menu/root.js";
import { MenuSeparator } from "../../../../../ui/menu/separator.js";
import { MenuTrigger } from "../../../../../ui/menu/trigger.js";
import { QualityRadioGroupOptions, QualityRadioGroupRoot, QualityRadioGroupValue } from "../../../../../ui/quality-radio-group/component.js";
import ForwardRef from "../../../../../icons/dist/react/default/switches.js";
import { MenuChevron } from "./menu-chevron.js";
import { RadioItem } from "./radio-item.js";
import { jsx, jsxs } from "react/jsx-runtime";
import { qualityText } from "@videojs/core/i18n/text/menu";
//#region src/internal/skins/default-video/components/menus/quality-menu.tsx
/** @jsxImportSource react */
function QualityMenu({ ...props } = {}) {
	return /* @__PURE__ */ jsx(MenuRoot, {
		...props,
		children: /* @__PURE__ */ jsxs(QualityRadioGroupRoot, { children: [/* @__PURE__ */ jsxs(MenuTrigger, {
			className: "media-menu-trigger-item",
			children: [
				/* @__PURE__ */ jsx(ForwardRef, { className: "media-menu-trigger-item-icon" }),
				/* @__PURE__ */ jsx(Text, {
					token: qualityText.key,
					children: qualityText.text
				}),
				/* @__PURE__ */ jsxs("span", {
					className: "media-menu-hint",
					children: [/* @__PURE__ */ jsx(QualityRadioGroupValue, { className: "media-menu-hint-label" }), /* @__PURE__ */ jsx(MenuChevron, {})]
				})
			]
		}), /* @__PURE__ */ jsxs(MenuContent, {
			className: "media-menu-content",
			children: [
				/* @__PURE__ */ jsxs(MenuItem, {
					className: "media-menu-back-item",
					children: [/* @__PURE__ */ jsx(MenuChevron, { back: true }), /* @__PURE__ */ jsx(Text, {
						token: qualityText.key,
						children: qualityText.text
					})]
				}),
				/* @__PURE__ */ jsx(MenuSeparator, { className: "media-menu-separator" }),
				/* @__PURE__ */ jsx(QualityRadioGroupOptions, {
					className: "media-menu-radio-group",
					renderItem: (props, item) => /* @__PURE__ */ jsxs(RadioItem, {
						...props,
						children: [/* @__PURE__ */ jsxs("span", { children: [/* @__PURE__ */ jsx("span", { children: item.label }), item.tier ? /* @__PURE__ */ jsx("sup", {
							className: "media-menu-tier",
							children: item.tier
						}) : null] }), item.badge ? /* @__PURE__ */ jsx("span", {
							className: "media-menu-badge",
							children: item.badge
						}) : null]
					})
				})
			]
		})] })
	});
}
//#endregion
export { QualityMenu };

//# sourceMappingURL=quality-menu.js.map